import script from "./Level.vue?vue&type=script&setup=true&lang=js"
export * from "./Level.vue?vue&type=script&setup=true&lang=js"

import "./Level.vue?vue&type=style&index=0&id=a2b93716&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2b93716"]])

export default __exports__